const getHtml = () => {
  return `
    <div>
      <h1>title</h1>
      <div>
        <p>This is the body of default Text</p>
      </div>
    </div>
  `;
};

const getCss = () => {
  return ``;
};

const getJs = () => {
  return ``;
};

const DefaultText = { getHtml, getCss, getJs };

export default DefaultText;
